"use strict";

var _classCallCheck = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Alignment_1 = require("./Alignment");
var Utils_1 = require("./Utils");
/**
 * StockholmAlignment
 * This class represents a Stockholm formatted multiple sequence alignment.
 *
 * Parser inspired by:
 *   https://github.com/biocore/scikit-bio/blob/master/skbio/io/format/stockholm.py
 *
 * The class should be instantiated using the static methods:
 *     fromFileContents: accepts a stockholm file-like string
 */
var StockholmAlignment = /*#__PURE__*/function (_Alignment_1$Alignmen) {
  _inherits(StockholmAlignment, _Alignment_1$Alignmen);
  function StockholmAlignment(name, sequencesAsInput, metadata) {
    var _this;
    _classCallCheck(this, StockholmAlignment);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(StockholmAlignment).call(this, name, sequencesAsInput));
    _this.metadata = metadata;
    return _this;
  }
  /**
   * Parse a string that contains a stockholm alignment.
   * @param fileName
   * @param fileContents
   * @throws an Error if the fileContents don't contain the expected
   *         header and footer.
   */
  _createClass(StockholmAlignment, [{
    key: "getMetadata",
    value: function getMetadata() {
      return this.metadata;
    }
  }], [{
    key: "fromFileContents",
    value: function fromFileContents(fileName, fileContents) {
      var trimmedAndSplit = fileContents.trim().split(/\r?\n/);
      // Raise an error if the header and footer don't indicate
      // that the file string is of stockholm format:
      //   header must start with "# STOCKHOLM 1.0"
      //   footer must be "//"
      if (trimmedAndSplit.length < 3) {
        throw Utils_1.getParseError("Stockholm", "The file length is less than 3 rows");
      }
      if (trimmedAndSplit[0].startsWith("# STOCKHOLM 1.0") === false) {
        throw Utils_1.getParseError("Stockholm", "The first line must be '# STOCKHOLM 1.0'");
      }
      if (trimmedAndSplit[trimmedAndSplit.length - 1] !== "//") {
        throw Utils_1.getParseError("Stockholm", "The last line must be '//'");
      }
      var metadata = {
        GF: {},
        GS: {},
        GR: {},
        GC: {}
      };
      var sequences = [];
      trimmedAndSplit.slice(1, trimmedAndSplit.length - 1).forEach(function (line, idx) {
        line = line.trim();
        if (!line.startsWith("#")) {
          //sequence line
          var split = line.match(/^(\S+)\s(.*)/).slice(1);
          sequences.push({
            id: split[0].trim(),
            sequence: split[1].trim()
          });
        } else {
          //metadata line
          if (line.length < 8 || ["GF", "GS", "GR", "GC"].includes(line.substr(2, 2)) === false) {
            console.warn("Unexpected metadata line in Stockholm alignment: " + line);
          } else {
            var metadataGroup = line.substr(2, 2);
            //match/slice splits on first whitespace. Taken from:
            //       https://stackoverflow.com/questions/10272773
            //Used multiple times and should reassess if it is the fastest. note
            //that safari had problems with str.split(/(?<=^\S+)\s/)
            var keyVal = line.substr(5).trim().match(/^(\S+)\s(.*)/).slice(1);
            keyVal[1] = keyVal[1].trim();
            if (metadataGroup === "GF") {
              if (keyVal[0] in metadata.GF === false) {
                metadata.GF[keyVal[0]] = keyVal[1];
              } else {
                metadata.GF[keyVal[0]] += " " + keyVal[1];
              }
            } else if (metadataGroup === "GS") {
              var seqId = keyVal[0];
              var featureVal = keyVal[1].trim().match(/^(\S+)\s(.*)/).slice(1);
              if (seqId in metadata.GS === false) {
                metadata.GS[seqId] = {};
              }
              if (featureVal[0] in metadata.GS[seqId] === false) {
                metadata.GS[seqId][featureVal[0]] = [];
              }
              metadata.GS[seqId][featureVal[0]].push(featureVal[1]);
            } else if (metadataGroup === "GR") {
              var _seqId = keyVal[0];
              var _featureVal = keyVal[1].trim().match(/^(\S+)\s(.*)/).slice(1);
              if (_seqId in metadata.GR === false) {
                metadata.GR[_seqId] = {};
              }
              metadata.GR[_seqId][_featureVal[0]] = _featureVal[1];
            } else if (metadataGroup === "GC") {
              metadata.GC[keyVal[0]] = keyVal[1];
            }
          }
        }
      });
      //console.log("metadata:", metadata);
      //console.log("sequences:", sequences);
      return new StockholmAlignment(fileName, sequences, metadata);
    }
  }]);
  return StockholmAlignment;
}(Alignment_1.Alignment);
exports.StockholmAlignment = StockholmAlignment;